export function previewText(value: string | null | undefined, limit = 140) {
  if (!value) return "";

  const compact = value.replace(/\s+/g, " ").trim();
  return compact.length > limit
    ? `${compact.slice(0, limit).trim()}...`
    : compact;
}
